import { render, staticRenderFns } from "./base-focus-trap.vue?vue&type=template&id=17985e66&"
import script from "./base-focus-trap.vue?vue&type=script&lang=js&"
export * from "./base-focus-trap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17985e66')) {
      api.createRecord('17985e66', component.options)
    } else {
      api.reload('17985e66', component.options)
    }
    module.hot.accept("./base-focus-trap.vue?vue&type=template&id=17985e66&", function () {
      api.rerender('17985e66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/base/base-focus-trap.vue"
export default component.exports